import { render, staticRenderFns } from "./MFormText.vue?vue&type=template&id=84bd36c4&"
import script from "./MFormText.vue?vue&type=script&lang=js&"
export * from "./MFormText.vue?vue&type=script&lang=js&"
import style0 from "./MFormText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84bd36c4')) {
      api.createRecord('84bd36c4', component.options)
    } else {
      api.reload('84bd36c4', component.options)
    }
    module.hot.accept("./MFormText.vue?vue&type=template&id=84bd36c4&", function () {
      api.rerender('84bd36c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MFormText.vue"
export default component.exports